import {
  Package,
  PackageCheck,
  PackageX,
  Truck,
} from "lucide-react";
import OrderStatCard from "./components/OrderStatCard";

const OrderTop = ({totalOrders, confirmedOrders, cancelOrders, pendingOrders}) => {
  return (
    <div
      className="card shadow-sm border-0 rounded-4 mb-4 mt-0"
      style={{ borderRadius: "10px" }}
    >
      <div className="card-body p-3">
        <div className="row">
          <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
            <OrderStatCard
              title="Total Orders"
              value={totalOrders || 0}
              bgGradient="linear-gradient(135deg,#4E342E,#6D4C41)"
              icon={Package}
            />
          </div>

          <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
            <OrderStatCard
              title="Pending Orders"
              value={pendingOrders || 0}
              bgGradient="linear-gradient(135deg,#8D6E63,#A1887F)"
              icon={Truck}
            />
          </div>


          <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
            <OrderStatCard
              title="Confirmed Orders"
              value={confirmedOrders || 0}
              bgGradient="linear-gradient(135deg,#6F4E37,#8B5E3C)"
              icon={PackageCheck}
            />
          </div>

          <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
            <OrderStatCard
              title="Cancelled"
              value={cancelOrders || 0}
              bgGradient="linear-gradient(135deg,#B85C38,#D2691E)"
              icon={PackageX}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrderTop;